// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteApiKeyModal_dialog__10E_c"};